import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

const playButtonDimensionSize = Theme.BU * 5;
let baseStyles = {
    container: {
        paddingBottom: Theme.primaryPaddingBottom,
        flexDirection: 'column'
    },
    header: {
        // No 'vertical' because we are overriding default values
        marginTop: 10,
        marginBottom: 10,
        paddingHorizontal: 24
    },
    detailContainer: {
        marginHorizontal: -Theme.primaryMargin
    },
    assetDetail: {
        marginTop: Theme.primaryMargin
    },
    imagePreviewContainer: {
        width: '100%',
        height: 'auto'
    },
    assetDetailContainer: {
        marginHorizontal: Theme.primaryMargin
    },
    previewImage: {
        flex: 1,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Theme.primaryBackgroundColor,
        width: '100%',
        aspectRatio: 16 / 9
    },
    playButton: {
        height: playButtonDimensionSize,
        width: playButtonDimensionSize
    },
    button: {
        marginVertical: 6
    },
    buttonsContainer: {
        marginTop: 9,
        marginBottom: 19,
        marginHorizontal: 0
    },
    carousel: {
        marginRight: -Theme.primaryMargin
    },
    infoText: {
        marginTop: 18,
        color: Theme.secondaryTextColor,
        fontSize: 16,
        fontFamily: Theme.regularFont
    },
    firstBlock: {},
    secondBlock: {},
    recommendedCarousel: {
        marginRight: -20
    },
    subtitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.secondaryTextColor,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        marginTop: 6,
        letterSpacing: -0.1
    },
    assetDetailConxtainer: {
        paddingHorizontal: 25
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        button: {
            ...baseStyles.button,
            alignSelf: 'stretch'
        },
        assetDetail: {
            marginTop: -18
        },
        detailContainer: {
            ...baseStyles.detailContainer,
            marginHorizontal: 0,
            marginBottom: Theme.primaryMargin,
            flex: 4
        },
        firstBlock: {
            ...baseStyles.firstBlock,
            flexDirection: 'column'
        },
        carousel: {
            ...baseStyles.carousel,
            marginTop: 30
        }
    };
}

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            flex: 1
        },
        detailContainer: {
            flex: 4,
            marginTop: 60
        },
        header: {
            top: 15,
            right: 15,
            zIndex: 1
        },
        previewImage: {
            width: '100%',
            height: 259,
            justifyContent: 'center',
            alignItems: 'center'
        },
        firstBlock: {
            ...baseStyles.firstBlock,
            flexDirection: 'column'
        }
    };
}

export default StyleSheet.create(baseStyles);
